export default "__VITE_ASSET__CEp2l3n9__"